<template>
    <div class="side-menu is-side-menu">

        <ul>
            <li v-on:click="onSelect(0)" :class="{active: curActiveTab == 0}" >
                <a href="#"><i class="icon icon-edit-2" :class="{active: curActiveTab == 0}"></i></a>
            </li>
            <li v-on:click="onSelect(1)" :class="{active: curActiveTab == 1}">
                <a href="#"><i class="icon icon-type" :class="{active: curActiveTab == 1}"></i></a>
            </li>
            <li v-on:click="onSelect(2)" :class="{active: curActiveTab == 2}" >
                <a href="#"><i class="icon icon-upload" :class="{active: curActiveTab == 2}"></i></a>
            </li>
            <li v-on:click="onSelect(4)" :class="{active: curActiveTab == 4}">
                <a href="#"> <i class="icon icon-layers" :class="{active: curActiveTab == 4}"></i></a>
            </li>
            <li v-on:click="onSelect(5)" :class="{active: curActiveTab == 5}">
                <a href="#"> <i class="icon icon-crosshair" :class="{active: curActiveTab == 5}"></i></a>
            </li>
        </ul>

        <!--
        <at-menu mode="vertical" class="is-at-menu" active-name="0" width="100%" theme="dark">
            <div v-on:click="onSelect(0)">
                <at-menu-item name="0" class="is-menu-item">
                <i class="icon icon-edit-2"></i> <br/>
                {{tabs[0]}}
                </at-menu-item>
            </div>
            
            <div v-on:click="onSelect(1)">
                <at-menu-item name="1" class="is-menu-item">
                <i class="icon icon-type"></i> <br/>
                {{tabs[1]}}
                </at-menu-item>
            </div>
            
            <div v-on:click="onSelect(2)">
                <at-menu-item name="2" class="is-menu-item">
                <i class="icon icon-upload"></i> <br/>
                {{tabs[2]}}
                </at-menu-item>
            </div>-->
            <!--
            <div v-on:click="onSelect(3)">
                <at-menu-item name="3" class="is-menu-item">
                <i class="icon icon-grid"></i> <br/>
                {{tabs[3]}}
                </at-menu-item>
            </div>

            
            <div v-on:click="onSelect(4)">
                <at-menu-item name="4" class="is-menu-item">
                <i class="icon icon-layers"></i> <br/>
                {{tabs[4]}}
                </at-menu-item>
            </div> 

            <div id="propertySideMenu" v-on:click="onSelect(5)">
                <at-menu-item name="5" class="is-menu-item">
                <i class="icon icon-crosshair"></i> <br/>
                {{tabs[5]}}
                </at-menu-item>
            </div>-->
        <!--</at-menu>-->  
    </div>
</template>

<script>
import { UIUpdate } from '../../lib/bezieLib/UI/UIUpdate';
export default {
    name: 'SideMenu',
    data: function(){
        return {
            tabs: ['Draw', 'Text', 'Upoads', 'Elements', 'Layers', 'Property'],
            component: ['Shapes', 'Text', 'Uploads', 'Elements', 'Layers', 'Property'],
            lastActiveTab: 0,
            curActiveTab: 0
        }
    },
    methods: { 
        onSelect: function(index){
            if(index >= 0 && index < this.component.length ){
                this.$emit('tab-selected',this.component[index]);
                if(index!=5){
                    //we dont want to store 'property' as the last tab as it is hidden.
                    this.lastActiveTab = index;
                }
                this.curActiveTab = index;
            }
        },
        onUpdate: function(obj, holdsMultipleSelectedItems){
            console.log("Side menu - on selection change called");
            if(obj){
                this.onSelect(5); //Selects property side menu
                //document.getElementById("propertySideMenu").click();
            }else{
                this.onSelect(this.lastActiveTab);
            }
        }
    },
    mounted: function(){
        UIUpdate.addSelectionChangeListener(this);
    },
    beforeDestroy: function(){
        UIUpdate.removeSelectionChangeListener(this);
    }
}
</script>

<style scoped>

.at-menu__item-link{
    padding-left: 20px !important;
}

.is-menu-item{
    margin: 5px;
}

.is-side-menu {
  background: #333;
  width: 50px;
}

.is-at-menu{
    height: 100%;
    min-height: 100%;
    margin: -5px 0px 0px 0px !important;
    border: 0px !important;
}

li{
    padding: 16px 0px 16px 0px;
    cursor: pointer;
}

li:hover{
    background: black;  
}

li.active{
    background: white;
}

a{
    color: white;
    text-decoration: none;
}

a:hover, .active{
    color: #333;
}

</style>